export default "__VITE_ASSET__DrlLjnpR__"